import Cookies from "js-cookie";
import { ConsentPreferences } from "../../types/consent";

const COOKIE_NAME = "user_consent_preferences";

export const saveConsent = (prefs: ConsentPreferences) => {
  const now = new Date();
  prefs['consentedAt'] = now.toString()
  Cookies.set(COOKIE_NAME, JSON.stringify(prefs), { expires: 365 });
}

export const getConsent = (): ConsentPreferences | null => {
  const raw = Cookies.get(COOKIE_NAME);
  return raw ? JSON.parse(raw) : null;
}

export const clearConsent = () => {
  try {
    Cookies.remove(COOKIE_NAME);
    Cookies.remove('consent_banner_seen');
  } catch {
    // noop
  }
}
